<mat-sidenav-container class="sidenav-container mat-app-background ">

  <mat-sidenav-content style=" overflow-y: hidden;">

    <div *ngIf="loaderService.isLoading | async" class="loader-container">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>

    <div class="row" style = "min-height:100vh">
      <div  class="col-xs-1 col-sm-4 col-md-4 col-lg-2 pr-0" style="color: white; padding-right: 0px;">

        <mat-nav-list *ngIf="!isHandSet" class="bgPrimary height-100">


          <div class="logoClass">
            <img class="logoImage" style="height: 80px;" src="assets/img/LogoTransparent_White.png">
          </div>

          <a class="text-white" mat-list-item [ngClass]="{selectedBut: globals.selectedRoute == 'dashboard'}"
            (click)="doNav('dashboard')">
            <mat-icon class="home_icon collapse-icon vcenter mr-18" mat-list-icon>speed</mat-icon>
            Dashboard
          </a>
          <a class="text-white" mat-list-item [ngClass]="{selectedBut: globals.selectedRoute == 'devicelist'}"
            (click)="doNav('devicelist')">
            <mat-icon class="home_icon collapse-icon vcenter mr-18" mat-list-icon>tap_and_play</mat-icon>
            Hotspots
          </a>

          <!-- <a mat-list-item href="#">Search</a> -->
        </mat-nav-list>
      </div>

      <div  class="col-xs-11 col-sm-8 col-md-8 col-lg-10 pl-0" style="padding-left: 0px;overflow-y: auto;">
        <mat-toolbar class="bgwhiteOverride ">

          <mat-icon *ngIf="isHandSet" class="menu_icon material-icons-outlined icon mr10-icon" [matMenuTriggerFor]="navMenu"
          matTooltip="" > menu</mat-icon>

          <mat-menu #navMenu="matMenu" xPosition="before">
            <button mat-menu-item (click)="doNav('dashboard')">Dashboard</button>
            <button mat-menu-item (click)="doNav('devicelist')">Hotspots</button>
          </mat-menu>

          <span style="flex:auto"></span>
          <span style="margin-right: 40px;"> <span class="user">{{globals.activeUser.name}}</span>
            <span class="logout-button pointer" (click)="logout()">Logout</span></span>



          <mat-icon class="menu_icon material-icons-outlined icon mr10-icon" [matMenuTriggerFor]="profileMenu"
            matTooltip="Profile"> account_circle</mat-icon>

          <mat-menu #profileMenu="matMenu" xPosition="before">
            <button mat-menu-item (click)="viewProfile()">View Profile</button>
            <button mat-menu-item (click)="logout()">Log out</button>
            <!-- <button mat-menu-item>
              <mat-slide-toggle [(ngModel)]="isDarkTheme" labelPosition="before" (change)="storeThemeSelection()">
                Dark mode
              </mat-slide-toggle>
            </button> -->


          </mat-menu>

        </mat-toolbar>

        <router-outlet></router-outlet>
      </div>
    </div>


  </mat-sidenav-content>

</mat-sidenav-container>
